import { Badge, Stack, Tabs, Text } from '@mantine/core'
import { useQueryParamTab } from 'src/utils/tabQueryParam'
import LessonManagementPanel from './LessonManagementPanel'

export const COURSE_AI_TABS = [
	{
		value: 'writing',
		label: 'Writing',
		lessonsLabel: '90 lessons',
		enabled: true,
	},
	{
		value: 'dictation',
		label: 'Dictation',
		lessonsLabel: '90 lessons',
		enabled: true,
	},
	{
		value: 'pronunciation',
		label: 'Pronunciation',
		lessonsLabel: '90 subjects',
		enabled: false,
	},
	{
		value: 'speaking',
		label: 'Speaking',
		lessonsLabel: '90 topics',
		enabled: false,
	},
	{
		value: 'combo',
		label: '3-Skill Combo',
		lessonsLabel: '90 days',
		enabled: false,
	},
] as const

export type CourseAiTabValue = (typeof COURSE_AI_TABS)[number]['value']

function CourseAiPage() {
	const tabValues = COURSE_AI_TABS.map((tab) => tab.value)
	const { activeTab, handleTabChange } = useQueryParamTab(
		tabValues,
		'writing',
	)

	return (
		<Stack
			sx={{
				width: '100%',
				padding: 14,
				border: '1px solid #e6ebe7',
				borderRadius: 10,
				background: '#fff',
			}}
		>
			<Stack spacing={4}>
				<Text size="xs" color="dimmed">
					AI Courses &gt; Lesson Management
				</Text>
				<Text fw={700} size="xl">
					Lesson Management
				</Text>
				<Text size="sm" color="dimmed">
					Manage lessons for 5 AI courses · fixed Day 1→90 prompts, all users
					share the same prompt each day
				</Text>
			</Stack>

			<Tabs
				value={activeTab}
				onTabChange={handleTabChange}
				keepMounted={false}
				sx={{
					'.mantine-Tabs-list': {
						gap: 8,
						borderBottom: '1px solid #edf2ee',
						paddingBottom: 8,
						flexWrap: 'wrap',
					},
					'.mantine-Tabs-tab': {
						paddingInline: 14,
						paddingBlock: 10,
						color: '#374151',
						borderRadius: 8,
						fontWeight: 700,
					},
					'.mantine-Tabs-tab[data-active="true"]': {
						color: '#1f7a44',
						background: '#ecfdf3',
					},
				}}
			>
				<Tabs.List>
					{COURSE_AI_TABS.map((tab) => (
						<Tabs.Tab
							key={tab.value}
							value={tab.value}
							disabled={!tab.enabled}
							rightSection={
								<Badge
									size="sm"
									variant="light"
									color={tab.enabled ? 'green' : 'gray'}
								>
									{tab.lessonsLabel}
								</Badge>
							}
						>
							{tab.label}
						</Tabs.Tab>
					))}
				</Tabs.List>

				{COURSE_AI_TABS.map((tab) => (
					<Tabs.Panel key={tab.value} value={tab.value} pt="md">
						{tab.enabled ? (
							<LessonManagementPanel skill={tab.value} />
						) : (
							<Text color="dimmed" size="sm">
								Coming soon — CMS API for {tab.label} will be added in
								Phase 2.
							</Text>
						)}
					</Tabs.Panel>
				))}
			</Tabs>
		</Stack>
	)
}

export default CourseAiPage
